import React from 'react'
import './WelcomeScreen.css'

const WelcomeScreen = () => {
  return (
    <div className="welcome-screen">
      <div className="welcome-header">
        <h1 className="welcome-title">
          OmniContext AI
        </h1>
        <p className="welcome-subtitle">
          Your intelligent conversation partner with contextual memory and multi-agent collaboration
        </p>
      </div>
    </div>
  )
}

export default WelcomeScreen
